import React from "react";
import { usePostHog } from "posthog-js/react";

interface AppStoreButtonProps {
  className?: string;
  darkText?: boolean;
}

const AppStoreButton: React.FC<AppStoreButtonProps> = ({
  className,
  darkText = false,
}) => {
  const posthog = usePostHog();
  const handleClick = () => {
    posthog?.capture("app_store_button_clicked", {
      url: "https://apps.apple.com/app/flateroo/id6683311358",
    });
  };
  return (
    <a
      href="https://apps.apple.com/app/flateroo/id6683311358"
      className={`flex items-center ${
        className || (darkText ? "bg-gray-900/10" : "bg-gray-100/20")
      } ${
        darkText ? "text-black" : "text-white"
      } px-4 py-3 rounded-lg hover:scale-110 transition-transform duration-300`}
      onClick={handleClick}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={`${process.env.PUBLIC_URL}/app-store-icon.svg`}
        alt="App Store Icon"
        className={`w-6 h-6 mr-2 ${darkText ? "invert" : ""}`}
      />
      <span className="text-base font-bold">App Store</span>
    </a>
  );
};

export default AppStoreButton;
